import EventBus from "../events/EventBus";
const RECAPTCHA_API_URL = 'https://www.google.com/recaptcha/api.js';
EventBus.on('modal:open', function (modal) {
    var _a;
    const key = (_a = modal === null || modal === void 0 ? void 0 : modal.dataset) === null || _a === void 0 ? void 0 : _a.recaptcha;
    if (!key || !window.grecaptcha) {
        return;
    }
    setTimeout(function () {
        grecaptcha.ready(function () {
            grecaptcha.execute(key, { action: modal.id.replace(/^mm-/, '').replace('-', '_') })
                .then(function (token) {
                modal.querySelector('[name=recaptcha]').value = token;
            });
        });
    }, 500);
});
const onLoadCallbackName = 'onRecaptchaLoad';
const callbacks = [];
let loading = false;
window[onLoadCallbackName] = function () {
    loading = false;
    callbacks.forEach(resolve => resolve(window.grecaptcha));
};
export function useRecaptcha() {
    return new Promise((resolve, fail) => {
        if (window.grecaptcha) {
            resolve(grecaptcha);
            return;
        }
        callbacks.push(resolve);
        if (loading) {
            return;
        }
        loading = true;
        const script = document.createElement('script');
        script.src = `${RECAPTCHA_API_URL}?onload=${onLoadCallbackName}&render=${process.env.RECAPTCHA_KEY}`;
        script.async = true;
        script.defer = true;
        script.onerror = () => fail('Failed to load Google Recaptcha');
        document.body.append(script);
    });
}
